import { Product } from "./product.model";


export interface Products {
  Channel: Product[];
  Connector: Product[];
  'Conversational model': Product[];
  Module: Product[];
}
